import { __assign, __extends } from "tslib";
import React from 'react';
import $ from 'jquery';
import { utils } from '../utils';
import { translationUtils, Consts, experiments, } from '@wix/photography-client-lib';
import FULLSCREEN_EVENTS from '../constants/fullscreenEvents';
import { isSEOMode } from '../utils/viewModeWrapper';
var FullscreenSidebar = /** @class */ (function (_super) {
    __extends(FullscreenSidebar, _super);
    function FullscreenSidebar(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isMobile: utils.isMobile(),
            isReadMoreVisible: false,
            isReadMoreOpen: false,
        };
        _this.descriptionRef = null;
        _this.handleDecsriptionKeyDown = _this.handleDecsriptionKeyDown.bind(_this);
        return _this;
    }
    FullscreenSidebar.prototype.fixTextsLineHeight = function (isReadMoreOpen) {
        var elem = this.itemContainer;
        var title = $(elem).find('.fullscreen-side-bar-title');
        var description = $(elem).find('.fullscreen-side-bar-description');
        var availableHeight = 150;
        var numberOfLinesRequired = 3;
        var spaceBetweenTitleAndDescription = 0;
        var originalTitleHeight = 0;
        var originalDescriptionHeight = 0;
        var titleLineHeight = parseInt(title.css('line-height'), 10) || 0;
        var numOfTitleLines = 0;
        var numOfDescriptionLines = 0;
        // reset truncation stuff
        title.css({ height: 'initial' });
        description.css({ height: 'initial' });
        title.css({ '-webkit-line-clamp': 'initial' });
        description.css({ '-webkit-line-clamp': 'initial' });
        if (title && title[0]) {
            // originalTitleHeight = title[0].scrollHeight - 18 //substructing the title margin-bottom
            originalTitleHeight = title[0].scrollHeight;
        }
        if (description && description[0]) {
            // originalDescriptionHeight = description[0].scrollHeight - 24 //substructing the description margin-bottom
            originalDescriptionHeight = description[0].scrollHeight;
        }
        if (!isReadMoreOpen) {
            var titleText = utils.getTitleOrFilename(this.props.current.item.title, this.props.fileName);
            if (this.props.styles.allowTitleExpand && titleText) {
                if (title && title.length !== 1) {
                    return;
                }
                spaceBetweenTitleAndDescription = 30;
                numOfTitleLines = this.truncateElement(availableHeight, numberOfLinesRequired, title, originalTitleHeight);
                var titleHeight = numOfTitleLines * titleLineHeight;
                if (availableHeight > titleHeight) {
                    availableHeight -= titleHeight;
                }
                else {
                    availableHeight = 0;
                }
            }
            if (this.props.styles.allowDescriptionExpand &&
                this.props.current.item.description) {
                if (description && description.length !== 1) {
                    return;
                }
                availableHeight -= spaceBetweenTitleAndDescription;
                if (availableHeight <= 0) {
                    description.hide();
                    return;
                }
                numOfDescriptionLines = this.truncateElement(availableHeight, numberOfLinesRequired - numOfTitleLines, description, originalDescriptionHeight);
                if (numOfDescriptionLines === 0) {
                    description.hide();
                }
            }
        }
        else {
            // all the title and description should be displayed
            if (this.props.current.item.isReadMoreOpen) {
                this.setState({ isReadMoreVisible: true });
            }
            title.css({ height: originalTitleHeight });
            description.css({
                height: originalDescriptionHeight,
                maxHeight: originalDescriptionHeight,
            });
            description.show();
            title.css({ '-webkit-line-clamp': 'initial' });
            description.css({ '-webkit-line-clamp': 'initial' });
        }
    };
    FullscreenSidebar.prototype.truncateElement = function (availableHeight, numberOfLinesRequired, element, originalElementHeight) {
        var numOfElementLines = 0;
        element.css({ overflow: 'visible' });
        var elementHeight = originalElementHeight;
        var elementLineHeight = parseInt(element.css('line-height'), 10) || 0;
        var originalNumberOfElementLines = Math.floor(elementHeight / elementLineHeight);
        numOfElementLines = Math.min(Math.floor(availableHeight / elementLineHeight), numberOfLinesRequired, originalNumberOfElementLines);
        if (numOfElementLines < originalNumberOfElementLines) {
            // need to truncate the element
            this.props.current.item.isReadMoreOpen = false;
            this.setState({ isReadMoreOpen: false });
            this.setState({ isReadMoreVisible: true });
            element.css({ '-webkit-line-clamp': numOfElementLines + '' });
            elementHeight = elementLineHeight * numOfElementLines;
            element.css({
                overflow: 'hidden',
                display: '-webkit-box',
                '-webkit-box-orient': 'vertical',
                height: elementHeight,
            });
        }
        else {
            // all the element can be displayed
            if (this.props.current.item.isReadMoreOpen) {
                this.setState({ isReadMoreVisible: true });
            }
            element.css({ '-webkit-line-clamp': 'initial' });
            elementHeight = elementLineHeight * originalNumberOfElementLines;
        }
        return numOfElementLines;
    };
    FullscreenSidebar.prototype.toggleReadMore = function () {
        this.props.current.item.isReadMoreOpen =
            !this.props.current.item.isReadMoreOpen;
        this.setState({ isReadMoreOpen: this.props.current.item.isReadMoreOpen });
        this.fixTextsLineHeight(this.curItem.isReadMoreOpen);
    };
    FullscreenSidebar.prototype.isVisible = function () {
        // Note: There are 2 props that are responsible for showing the sidebar: 'showInfo' and 'shouldShowInfo' - probably historic reasons..
        return (((this.props.showInfo || this.props.shouldShowInfo) &&
            (this.props.current.hasInfo || this.props.customSidebarRenderer)) ||
            this.props.isAdditionalMobileSidebarOpened === true);
    };
    FullscreenSidebar.prototype.getAdditionalSidebarElement = function () {
        var additionalSidebarElement = this.props.additionalSidebarElement;
        try {
            if (additionalSidebarElement) {
                return additionalSidebarElement(__assign(__assign({}, this.props), { styleParams: this.props.styles }));
            }
            else {
                return false;
            }
        }
        catch (e) {
            console.error('Could not get additional sidebar element', e);
        }
    };
    FullscreenSidebar.prototype.hasAdditionalSidebarElement = function () {
        if (utils.isMobile()) {
            var customMobileSidebarRenderer = this.props.customMobileSidebarRenderer;
            return typeof customMobileSidebarRenderer === 'function';
        }
        else {
            var additionalSidebarElement = this.props.additionalSidebarElement;
            return typeof additionalSidebarElement === 'function';
        }
    };
    FullscreenSidebar.prototype.onKeyPress = function (e, onClickFunction) {
        switch (e.keyCode || e.charCode) {
            case 32: // space
            case 13: // enter
                e.preventDefault();
                onClickFunction();
                return false;
        }
    };
    FullscreenSidebar.prototype.componentDidUpdate = function (prevProps) {
        if (this.hasAdditionalSidebarElement()) {
            if (prevProps.current.item.id !== this.props.current.item.id) {
                // we are dealing with a new item
                if (this.state.isReadMoreVisible) {
                    this.setState({ isReadMoreVisible: false });
                }
                this.setState({
                    isReadMoreOpen: this.props.current.item.isReadMoreOpen,
                });
                this.fixTextsLineHeight(this.curItem.isReadMoreOpen);
            }
        }
    };
    FullscreenSidebar.prototype.componentDidMount = function () {
        if (this.hasAdditionalSidebarElement()) {
            this.fixTextsLineHeight(this.curItem.isReadMoreOpen);
        }
        window.addEventListener('keydown', this.handleDecsriptionKeyDown);
    };
    FullscreenSidebar.prototype.componentWillUnmount = function () {
        window.removeEventListener('keydown', this.handleDecsriptionKeyDown);
    };
    FullscreenSidebar.prototype.handleDecsriptionKeyDown = function (e) {
        switch (e.keyCode || e.charCode) {
            case 38: // up
                this.descriptionRef.scrollBy({ top: -50, behavior: 'smooth' });
                return false;
            case 40: // down
                this.descriptionRef.scrollBy({ top: 50, behavior: 'smooth' });
                return false;
                break;
            default:
        }
    };
    FullscreenSidebar.prototype.render = function () {
        var _this = this;
        var curItem = (this.curItem = this.props.current.item);
        var _a = this.state, isReadMoreVisible = _a.isReadMoreVisible, isMobile = _a.isMobile, isReadMoreOpen = _a.isReadMoreOpen;
        var hasAdditionalSidebarElement = this.hasAdditionalSidebarElement();
        var isStoreMobile = hasAdditionalSidebarElement && isMobile;
        var titleText = utils.getTitleOrFilename(curItem.title, curItem.fileName) || ''; // (curItem.isDemo ? curItem.demoTitle : ''); - remove default text from demo items until rewritten
        var title = titleText && this.props.styles.allowTitleExpand && !isStoreMobile ? (React.createElement("div", { className: "fullscreen-side-bar-title", tabIndex: -1 },
            React.createElement("h1", null, titleText))) : null;
        var descriptionText = curItem.description || '';
        var description;
        if (descriptionText &&
            this.props.styles.allowDescriptionExpand &&
            !isStoreMobile) {
            var descriptionClassName = 'fullscreen-side-bar-description';
            descriptionClassName += hasAdditionalSidebarElement
                ? ' pro-fullscreen-store'
                : '';
            description = (React.createElement("div", { className: descriptionClassName, tabIndex: -1, ref: function (ref) { return (_this.descriptionRef = ref); } },
                React.createElement("div", { className: "fullscreen-side-bar-description-line", style: { whiteSpace: 'pre-wrap' } }, descriptionText)));
        }
        else {
            description = null;
        }
        var prettyExif = '';
        if (curItem.exif) {
            var camera = curItem.exif.Model;
            // todo - place separators using join
            var focalLength = curItem.exif.FocalLength ? (React.createElement("span", null,
                curItem.exif.FocalLength,
                "mm")) : ('');
            var fNumber = curItem.exif.FNumber ? (React.createElement("span", null,
                "\u00A0\u00A0/\u00A0\u00A0\u0192/",
                curItem.exif.FNumber)) : ('');
            var roundExposureTime = Math.round(1 / Number(curItem.exif.ExposureTime));
            var exposureTime = roundExposureTime > 0 ? (React.createElement("span", null,
                "\u00A0\u00A0/\u00A0\u00A01/",
                roundExposureTime,
                "s")) : ('');
            var isoSpeed = curItem.exif.IsoSpeed ? (React.createElement("span", null,
                "\u00A0\u00A0/\u00A0\u00A0ISO ",
                curItem.exif.IsoSpeed)) : ('');
            var showExif = focalLength || fNumber || exposureTime || isoSpeed;
            prettyExif =
                showExif &&
                    this.props.styles.allowExifExpand &&
                    !hasAdditionalSidebarElement ? (React.createElement("div", { className: "fullscreen-side-bar-exif" },
                    React.createElement("div", { className: "exif-camera" }, camera),
                    React.createElement("div", { className: "exif-shot" },
                        focalLength,
                        fNumber,
                        exposureTime,
                        isoSpeed))) : ('');
        }
        /*
         var allExif = [];
         for (var field in curItem.exif) {
         if (curItem.exif.hasOwnProperty(field)) {
         allExif.push(
         <p>{field}: {curItem.exif[field]}</p>
         )
         }
         }
    
         <p className="exif-more">see all</p>
         <div className="exif-all">
         {allExif}
         </div>
         */
        var getLinkIfNeeded = function () {
            var shouldShowLink = curItem.hasLink &&
                _this.props.styles.allowLinkExpand &&
                !isStoreMobile &&
                (hasAdditionalSidebarElement
                    ? curItem.hasLink && (!isReadMoreVisible || isReadMoreOpen)
                    : true);
            if (!shouldShowLink) {
                return '';
            }
            var linkClassNames = 'fullscreen-side-bar-link pro-fullscreen-link';
            linkClassNames += hasAdditionalSidebarElement
                ? ' pro-fullscreen-store'
                : '';
            var isSEO = isSEOMode();
            var noFollowForSEO = _this.props.noFollowForSEO;
            var shouldUseNofollow = isSEO && noFollowForSEO;
            var seoLinkParams = shouldUseNofollow ? { rel: 'nofollow' } : {};
            var _a = _this.curItem.directLink || {}, url = _a.url, target = _a.target;
            var shouldUseDirectLink = !!(url && target);
            if (shouldUseDirectLink) {
                return (React.createElement("a", __assign({ className: linkClassNames, href: url, target: target }, seoLinkParams, { tabIndex: _this.isVisible() ? utils.getTabIndex('fullscreenLink') : -1, "aria-label": curItem.linkText }), curItem.linkText || curItem.linkUrl));
            }
            else {
                return (React.createElement("a", { className: linkClassNames, onClick: function () {
                        return _this.props.actions.eventsListener(FULLSCREEN_EVENTS.NAVIGATE, curItem);
                    }, onKeyDown: function (e) {
                        return _this.onKeyPress(e, function () {
                            return _this.props.actions.eventsListener(FULLSCREEN_EVENTS.NAVIGATE, curItem);
                        });
                    }, tabIndex: _this.isVisible() ? utils.getTabIndex('fullscreenLink') : -1, "aria-label": curItem.linkText }, curItem.linkText || curItem.linkUrl));
            }
        };
        var readLess = translationUtils
            ? translationUtils.getByKey('Gallery_Read_Less')
            : 'read_less';
        var readMore = translationUtils
            ? translationUtils.getByKey('Gallery_Read_More')
            : 'read_more';
        var readMoreText = isReadMoreOpen ? readLess : readMore;
        var readMoreOrLess = isReadMoreVisible ? (React.createElement("div", { className: "pro-fullscreen-read-more fullscreen-side-bar-description", onClick: function () { return _this.toggleReadMore(); } }, readMoreText)) : null;
        var infoContainerClassName = 'fullscreen-side-bar-info-container';
        infoContainerClassName += hasAdditionalSidebarElement
            ? ' pro-fullscreen-store'
            : '';
        // infoContainerClassName += (isSmallScreen ? '' : ' mCustomScrollbar pro-fullscreen-custom-scroller');
        infoContainerClassName += hasAdditionalSidebarElement
            ? isMobile
                ? ''
                : ' pro-fullscreen-custom-scroller'
            : '';
        var isBottomInfo = this.props.styles.expandInfoPosition ===
            Consts.expandInfoPositions.BOTTOM;
        var isSidebarOpened = this.isVisible() ||
            (!this.props.currentWindow.expanded &&
                hasAdditionalSidebarElement &&
                !this.state.isMobile);
        var infoContainerStyle = isBottomInfo && !isMobile
            ? {
                maxHeight: Consts.expandInfoBottomPadding.MAX_HEIGHT,
                overflowY: 'auto',
            }
            : {};
        var limitBottomInfo = isBottomInfo && !isMobile
            ? { width: '700px', left: 'calc(50% - 350px)', height: '20vh' }
            : {};
        var style = __assign({ textAlign: this.props.styles.galleryAlignExpand, transform: "scale(".concat(isSidebarOpened ? 1 : 0, ")") }, limitBottomInfo);
        if (this.props.customSidebarRenderer) {
            return (React.createElement("div", { className: 'fullscreen-side-bar' +
                    (isBottomInfo ? '-bottom' : '') +
                    (isSidebarOpened
                        ? ' pro-fullscreen-opened'
                        : ' pro-fullscreen-closed') +
                    (isMobile ? ' pro-fullscreen-mobile' : ''), style: style, "aria-hidden": !isSidebarOpened }, this.props.customSidebarRenderer(__assign(__assign({}, this.props), { styleParams: this.props.styles }))));
        }
        else {
            return (React.createElement("div", { className: 'fullscreen-side-bar' +
                    (isBottomInfo ? '-bottom' : '') +
                    (isSidebarOpened
                        ? ' pro-fullscreen-opened'
                        : ' pro-fullscreen-closed') +
                    (isMobile ? ' pro-fullscreen-mobile' : '') +
                    (hasAdditionalSidebarElement ? ' pro-fullscreen-store' : ''), style: style, "aria-hidden": !isSidebarOpened },
                React.createElement("div", { className: infoContainerClassName, style: infoContainerStyle },
                    React.createElement("div", { ref: function (itemContainer) {
                            _this.itemContainer = itemContainer;
                        } },
                        title,
                        description),
                    prettyExif,
                    getLinkIfNeeded(),
                    readMoreOrLess,
                    this.getAdditionalSidebarElement())));
        }
    };
    return FullscreenSidebar;
}(React.Component));
export default FullscreenSidebar;
//# sourceMappingURL=fullscreenSidebar.js.map